module.exports = "<template>\r\n    <div ref=\"element\" id.bind=\"pieName\" class=\"chart\"></div>\r\n</template>\r\n";